import React from "react";

const CopyIcon = ({ height = 15, width = 15, className }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12.75 4C13.9004 4 14.8327 4.93271 14.833 6.08301V12.75C14.833 13.9006 13.9006 14.833 12.75 14.833H6.08301C4.93271 14.8327 4 13.9004 4 12.75V6.08301C4.00035 4.93293 4.93293 4.00035 6.08301 4H12.75ZM6.08301 5.5C5.76136 5.50035 5.50035 5.76136 5.5 6.08301V12.75C5.5 13.0719 5.76114 13.3327 6.08301 13.333H12.75C13.0722 13.333 13.333 13.0722 13.333 12.75V6.08301C13.3327 5.76114 13.0719 5.5 12.75 5.5H6.08301ZM8.75 0C9.89733 2.59185e-07 10.8327 0.935758 10.833 2.08301C10.833 2.49722 10.4972 2.83301 10.083 2.83301C9.66909 2.83266 9.33301 2.497 9.33301 2.08301C9.33265 1.76418 9.0689 1.5 8.75 1.5H2.08301C1.7644 1.50036 1.50036 1.7644 1.5 2.08301V8.75C1.5 9.0689 1.76418 9.33265 2.08301 9.33301C2.497 9.33301 2.83266 9.66909 2.83301 10.083C2.83301 10.4972 2.49722 10.833 2.08301 10.833C0.935758 10.8327 2.59181e-07 9.89733 0 8.75V2.08301C0.000353712 0.935975 0.935975 0.000353712 2.08301 0H8.75Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default CopyIcon;
